/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProductionReportQuery } from '../../models/get-production-report-query';
import { GetProductionReportQueryResult } from '../../models/get-production-report-query-result';

export interface ApiNurseryManagerReportsGetProductionReportPost$Params {
      body?: GetProductionReportQuery
}

export function apiNurseryManagerReportsGetProductionReportPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetProductionReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProductionReportQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetProductionReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProductionReportQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetProductionReportPost.PATH = '/api/NurseryManager/Reports/GetProductionReport';
